// src/pages/ErrorPage.jsx
import { useRouteError, isRouteErrorResponse } from 'react-router';
import { Page, Card, BlockStack, Box, Button, Text } from '@shopify/polaris';
import React from 'react';
import logo from '#client/assets/images/ww-logo-allcompany-black.png';

import './ErrorPage.css';

export default function ErrorPage(props) {
    const error = useRouteError();

    let message = props.message || 'Something went wrong.';
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            message = 'Page not found';
        } else {
            message = error.statusText || message;
        }
    }

    return (
        <Box className="error-page">
            <Box className="error-info">
                <Page>
                    <Box className="logo">
                        <img src={logo} alt="Work World App" />
                    </Box>
                    <Card>
                        <BlockStack gap="300">
                            <Box padding="400">
                                <Text variant="heading2xl">{message}</Text>

                                <Box paddingBlockStart="800">
                                    <Button monochrome variant="primary" url="/dashboard">
                                        Back to Dashboard
                                    </Button>
                                </Box>
                            </Box>
                        </BlockStack>
                    </Card>
                </Page>
            </Box>
        </Box>
    );
}
